<div class="node-lifecycle-container">
    <div class="node-data">
        <span><b>Node #{{id}}</b></span>
        <span *ngIf="!!nodeStatus" class="status-text">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            CONNECTED: {{nodeConfiguration?.address}}
        </span>
    </div>
    <div class="lifecycle-graph">
        <div class="lifecycle-item">
            <div class="graph-indicator" [ngClass]="{'active': nodeStatusInactive()}">
                Initial state
            </div>
            <div *ngIf="nodeStatusInactive()" class="action-buttons">
                <button (click)="startParserLearning()" [disabled]="executingAction" class="button supermini outline">Start learning</button>
                <button (click)="skipParserLearning()" [disabled]="executingAction" class="button supermini outline">Skip parser</button>
            </div>
        </div>
        <div class="lifecycle-item">
            <div class="graph-indicator" [ngClass]="{'active': nodeStatusParserLearning()}">
                Parser learning
            </div>
            <div *ngIf="nodeStatusParserLearning()" class="action-buttons">
                <button (click)="finishWork()" [disabled]="executingAction" class="button supermini outline">Force stop</button>
                <button (click)="cancelNodeCurrentWork()" [disabled]="executingAction" class="button supermini outline">Cancel</button>
            </div>
        </div>
        <div class="lifecycle-item">
            <div class="graph-indicator" [ngClass]="{'active': nodeStatusParserLearningFinished()}">
                Parser learning finished
            </div>
            <div *ngIf="nodeStatusParserLearningFinished()" class="action-buttons">
                <button (click)="resetWork()" [disabled]="executingAction" class="button supermini outline">Restart</button>
                <button (click)="startDetectorLearning()" [disabled]="executingAction" class="button supermini outline">Start detector</button>
            </div>
        </div>
        <div class="lifecycle-item">
            <div class="graph-indicator" [ngClass]="{'active': nodeStatusDetectorLearning()}">
                Detector learning
            </div>
            <div *ngIf="nodeStatusDetectorLearning()" class="action-buttons">
                <button (click)="cancelNodeCurrentWork()" [disabled]="executingAction" class="button supermini outline">Cancel</button>
                <button (click)="finishWork()" [disabled]="executingAction" class="button supermini outline">Force stop</button>
            </div>
        </div>
        <div class="lifecycle-item">
            <div class="graph-indicator" [ngClass]="{'active': nodeStatusDetectorLearningFinished()}">
                Detector learning finished
            </div>
            <div *ngIf="nodeStatusDetectorLearningFinished()" class="action-buttons">
                <button (click)="resetWork()" [disabled]="executingAction" class="button supermini outline">Restart</button>
                <button (click)="modifyNodeFeatures()" [disabled]="executingAction" class="button supermini outline">Modify features</button>
                <button (click)="startWorking()" [disabled]="executingAction" class="button supermini outline">Start operating</button>
            </div>
        </div>
        <div class="lifecycle-item">
            <div class="graph-indicator" [ngClass]="{'active': nodeStatusOperating()}">
                Operating
            </div>
            <div *ngIf="nodeStatusOperating()" class="action-buttons">
                <button (click)="modifyNodeFeatures()" [disabled]="executingAction" class="button supermini outline">Modify features</button>
                <button (click)="resetWork()" [disabled]="executingAction" class="button supermini outline">Restart</button>
                <button (click)="cancelNodeCurrentWork()" [disabled]="executingAction" class="button supermini outline">Cancel</button>
            </div>
        </div>
    </div>
    <div class="tabs-container">
        <button *ngIf="!!nodeStatus?.parserLearning" (click)="currentTab = tabParser" class="tab" [ngClass]="{'active': currentTab == tabParser}">Parser module</button>
        <button *ngIf="!!nodeStatus?.detectorLearning" (click)="currentTab = tabDetector" class="tab" [ngClass]="{'active': currentTab == tabDetector}">Detector module</button>
        <button *ngIf="diagnosisTabEnabled()" (click)="selectDiagnosisTab()" class="tab" [ngClass]="{'active': currentTab == tabDiagnosis}">Diagnosis data</button>
    </div>
    <div [hidden]="currentTab !== tabParser" class="lifecycle-data-container">
        <div class="lifecycle-data">
            <div class="lifecycle-parser-data">
                <div *ngIf="parserTabActive()" class="lc-params">
                    <div class="lc-field">
                        <span class="lcf-title">
                            Timestamp
                        </span>
                        <span class="lcf-content">
                            {{nodeStatus?.parserLearning?.timestamp}}
                        </span>
                    </div>
                    <div class="lc-field">
                        <span class="lcf-title">
                            Time limit
                        </span>
                        <span class="lcf-content">
                            {{nodeStatus?.parserLearning?.timeLimit}} h
                        </span>
                    </div>
                    <div class="lc-field">
                        <span class="lcf-title">
                            Time limit w/o features
                        </span>
                        <span class="lcf-content">
                            {{nodeStatus?.parserLearning?.timeLimitWithoutFeatures}} h
                        </span>
                    </div>
                    <div class="lc-field">
                        <span class="lcf-title">
                            Generated features: NETFLOW
                        </span>
                        <span class="lcf-content">
                            {{nodeStatus?.parserLearning!.generatedFeatures['netflow']}}
                        </span>
                    </div>
                    <div class="lc-field">
                        <span class="lcf-title">
                            Generated features: SNMP
                        </span>
                        <span class="lcf-content">
                            {{nodeStatus?.parserLearning!.generatedFeatures['snmp']}}
                        </span>
                    </div>
                    <div class="lc-field">
                        <span class="lcf-title">
                            Generated features: SYSLOG
                        </span>
                        <span class="lcf-content">
                            {{nodeStatus?.parserLearning!.generatedFeatures['syslog']}}
                        </span>
                    </div>
                    <div class="lc-field">
                        <span class="lcf-title">
                            Total generated features
                        </span>
                        <span class="lcf-content">
                            {{nodeStatus?.parserLearning?.totalGeneratedFeatures}}
                        </span>
                    </div>
                </div>
                <div class="lc-charts">
                    <div class="lc-chart">
                        <div id="totalGeneratedFeaturesEvoChart"></div>
                    </div>
                    <div class="lc-chart">
                        <div id="netflowEvolutionChart"></div>
                    </div>
                    <div class="lc-chart">
                        <div id="syslogEvolutionChart" ></div>
                    </div>
                    <div class="lc-chart">
                        <div id="snmpEvolutionChart"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div [hidden]="currentTab !== tabDetector" class="lifecycle-data-container">
        <div *ngIf="detectorTabActive()" class="lifecycle-data">
            <div class="lifecycle-detector-data">
                <div class="lc-params">
                    <div class="lc-field">
                        <span class="lcf-title">
                            Timestamp
                        </span>
                        <span class="lcf-content">
                            {{nodeStatus?.detectorLearning?.timestamp}}
                        </span>
                    </div>
                    <div class="lc-field">
                        <span class="lcf-title">
                            Time limit (hours)
                        </span>
                        <span class="lcf-content">
                            {{nodeStatus?.detectorLearning?.timeLimitHours}} h
                        </span>
                    </div>
                    <div class="lc-field">
                        <span class="lcf-title">
                            UCL Variation Percentage Limit
                        </span>
                        <span class="lcf-content">
                            {{(nodeStatus?.detectorLearning?.uclVariationPercentage ?? 0) * 100}}%
                        </span>
                    </div>
                    <div class="lc-field">
                        <span class="lcf-title">
                            UCLd Variation
                        </span>
                        <span class="lcf-content">
                            {{(nodeStatus?.detectorLearning?.ucLdVariation ?? 0) * 100}} %
                        </span>
                    </div>
                    <div class="lc-field">
                        <span class="lcf-title">
                            UCLq Variation
                        </span>
                        <span class="lcf-content">
                            {{(nodeStatus?.detectorLearning?.ucLqVariation ?? 0) * 100}} %
                        </span>
                    </div>
                </div>
                <div class="lc-charts">
                    <div [hidden]="!nodeStatus?.detectorLearning?.ucLdEvolution" class="lc-chart">
                        <div id="ucldEvolutionChart" #ucldEvolutionChart></div>
                    </div>
                    <div [hidden]="!nodeStatus?.detectorLearning?.ucLqEvolution" class="lc-chart">
                        <div id="uclqEvolutionChart"></div>
                    </div>
                    <div [hidden]="!nodeStatus?.detectorLearning?.ucLdVariationEvolution" class="lc-chart">
                        <div id="ucldVariationEvolutionChart"></div>
                    </div>
                    <div [hidden]="!nodeStatus?.detectorLearning?.ucLqVariationEvolution" class="lc-chart">
                        <div id="uclqVariationEvolutionChart"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div [hidden]="currentTab !== tabDiagnosis" class="lifecycle-data-container">
        <app-node-diagnosis #nodeDiagnosisView [nodeId]="id" [nodeIdentifier]="nodeGuid"></app-node-diagnosis>
    </div>
</div>